import { FormattedMessage } from 'react-intl';

import { Chip } from '@sorare/core/src/atoms/ui/Chip';

export const PromoChip = () => {
  return (
    <Chip color="glow" size="compact">
      <FormattedMessage id="navigationCart.promo" defaultMessage="Promo" />
    </Chip>
  );
};
